import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=50d68b5b&scoped=true&"
import script from "./IconClose.vue?vue&type=script&lang=js&"
export * from "./IconClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../royaumes/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d68b5b",
  null
  
)

export default component.exports